import React from "react";
import { motion } from "framer-motion";

// Staggered fade-up reveal on scroll into view
export const Reveal = ({ children, delay = 0, y = 40, className = "", ...props }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    {...props}
  >
    {children}
  </motion.div>
);

export const SectionHeader = ({ label, title, desc, center = false }) => (
  <div className={center ? "text-center max-w-3xl mx-auto" : "max-w-3xl"}>
    <Reveal>
      <span className="text-xs md:text-sm font-semibold tracking-[0.25em] uppercase text-jo-accent">
        {label}
      </span>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="mt-4 text-4xl md:text-5xl font-bold tracking-tight text-jo-primary leading-[1.05]">
        {title}
      </h2>
    </Reveal>
    {desc && (
      <Reveal delay={0.16}>
        <p className="mt-5 text-base md:text-lg text-slate-600 font-light leading-relaxed">
          {desc}
        </p>
      </Reveal>
    )}
  </div>
);
